import { isPositiveNumber } from "../../utils/formValidation";
import Button from "../../components/ui/Button";
import Modal from "../../components/ui/Modal";
import React, { useState, useEffect } from "react";
import "./SetFxPricingModal.css";
import { FxRate } from "../../types/fx";
import { updateRate } from "../../services/fxService";
import { getApiErrorMessage } from "../../utils/apiError";

interface ModalProps {
  onClose: () => void;
  onSuccess: () => void;
  editingRate: FxRate | null; // Can be null if we were creating
}

const SetFxPricingModal: React.FC<ModalProps> = ({
  onClose,
  onSuccess,
  editingRate,
}) => {
  const [buyRate, setBuyRate] = useState<number | "">("");
  const [sellRate, setSellRate] = useState<number | "">("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (editingRate) {
      setBuyRate(editingRate.buyRate);
      setSellRate(editingRate.sellRate);
    }
  }, [editingRate]);

  const handleSave = async () => {
    // Guard clause to ensure we are in edit mode
    if (!editingRate) {
      setError("No rate selected to edit.");
      return;
    }
    if (!isPositiveNumber(buyRate) || !isPositiveNumber(sellRate)) {
      setError("Enter positive buy and sell rates.");
      return;
    }
    setLoading(true);
    setError(null);

    try {
      // === THIS IS THE FIX ===
      // Construct the full object that the updated `updateRate` function expects.
      await updateRate({
        id: editingRate.id,
        fromCurrency: editingRate.fromCurrency,
        toCurrency: editingRate.toCurrency,
        buyRate: Number(buyRate),
        sellRate: Number(sellRate),
      });
      onSuccess();
    } catch (err) {
      setError(getApiErrorMessage(err, "Failed to update the rate."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal title={<>Edit FX Rate</>} onClose={onClose} size="medium">
<div className="fx-pricing-modal legacy-modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-body">
          <div className="form-group">
            <label>Currency Pair</label>
            <div className="custom-select-wrapper">
              <input
                type="text"
                value={`${editingRate?.fromCurrency} / ${editingRate?.toCurrency}`}
                readOnly
              />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Buy Rate</label>
              <input
                type="number" min="0.000001" step="any"
                placeholder="Enter buy rate"
                value={buyRate}
                onChange={(e) => setBuyRate(parseFloat(e.target.value) || "")}
              />
            </div>
            <div className="form-group">
              <label>Sell Rate</label>
              <input
                type="number" min="0.000001" step="any"
                placeholder="Enter sell rate"
                value={sellRate}
                onChange={(e) => setSellRate(parseFloat(e.target.value) || "")}
              />
            </div>
          </div>
          {error && <p className="modal-error">{error}</p>}
        </div>
        <div className="modal-footer">
          <Button type="button" className="cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="button"
            className="set-price-btn"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Updating..." : "Update Rate"}
          </Button>
        </div>
      </div>
</Modal>
  );
};

export default SetFxPricingModal;
